module.exports = __webpack_public_path__ + "static/media/17.7cae752e.png";